import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require("react");
import { Teaser } from "./teaser";
export class GridBlock extends React.Component {
    render() {
        const p = this.props;
        return /*#__PURE__*/ _jsx("section", {
            className: "block block--collections collections",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "block__inner container--lg align--center",
                children: [
                    p.title && /*#__PURE__*/ _jsx("header", {
                        className: "block__header",
                        children: /*#__PURE__*/ _jsx("h2", {
                            className: "block__title title--l",
                            children: p.title
                        })
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        className: "row teasers",
                        children: p.items.map((item, index)=>/*#__PURE__*/ _jsx(Teaser, {
                                title: item.title,
                                headingLevel: "h2",
                                intro: item.intro,
                                imageUrl: item.imageUrl,
                                imageUrlFallback: item.imageUrlFallback,
                                imageUrlLarge: item.imageUrlLarge,
                                imageAlt: item.imageAlt,
                                linkUrl: item.linkUrl,
                                extraClasses: `block__item col-xs-12 col-sm-${p.row_count == 4 ? 6 : 4} col-md-${12 / p.row_count}`
                            }, `grid-item-${index}`))
                    })
                ]
            })
        });
    }
}
{}